import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompContext, useCompFormContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { ComponentSettingKey } from '@/shared/builder'

import { CompSelectWrapperCore } from '../core/forms/select/wrapper'
import { CompSelect } from './CompSelect'

/**
 * CompSelectWrapper
 */
const CompSelectWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer }

  // form
  const formContext = useCompFormContext()

  // tableData
  const { dbClient, loadedTables, tablesMap } = useDbClientContext()
  const tableId = compContext.settings[ComponentSettingKey.SelectionDataOptionsSource] // options table id
  const dbTable = tableId ? tablesMap.get(tableId) : undefined
  const isLoadingData = !loadedTables.has(tableId)

  if (isLoadingData) {
    return (
      <div className='w-full mk-form-field'>
        <div className='animate-pulse w-full h-14 bg-zinc-300 rounded-sm' />
      </div>
    )
  }

  if (!dbClient || !dbTable) {
    return (
      <div className='flex justify-center items-center py-2'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompSelectWrapperCore infos={infosProps} form={formContext} tableData={{ dbClient, dbTable, tableId }}>
      {(props) => <CompSelect {...props} />}
    </CompSelectWrapperCore>
  )
}

export default CompSelectWrapper
